import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as Dialog from '@radix-ui/react-dialog';
import * as Switch from '@radix-ui/react-switch';
import * as styles from './CookiePreferencesModal.module.scss';
import { resolveRichText } from '../../../utils/richText';

const CookiePreferencesModal = ({ preferences, onSave, onClose, open, settings }) => {
  const [localPreferences, setLocalPreferences] = useState(preferences);
  const modalDesc = resolveRichText(settings.cookie_modal_description);
  const modalStrictly = resolveRichText(settings.cookie_modal_strictly_desc);
  const modalPerformance = resolveRichText(settings.cookie_modal_performance_desc);
  const modalTargeting = resolveRichText(settings.cookie_modal_targeting_desc);

  const handleToggle = (key) => {
    if (key !== 'necessary') {
      setLocalPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const handleSave = () => {
    onSave(localPreferences);
  };

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.dialogOverlay} />
        <Dialog.Content className={styles.dialogContent}>
          <Dialog.Title className={styles.dialogTitle}>{settings.cookie_modal_title}</Dialog.Title>
          <Dialog.Description
            className={styles.dialogDescription}
            dangerouslySetInnerHTML={modalDesc}
          ></Dialog.Description>

          <div className={styles.cookieOptions}>
            <div className={styles.option}>
              <div className={styles.optionHeader}>
                <h3>
                  <FormattedMessage id='component.cookie_modal.strictly_title' />
                </h3>

                <div className={styles.switchWrapper}>
                  <span>
                    <FormattedMessage id='component.cookie_modal.always_active' />
                  </span>
                </div>
              </div>
              <p dangerouslySetInnerHTML={modalStrictly}></p>
            </div>

            <div className={styles.option}>
              <div className={styles.optionHeader}>
                <h3>
                  <FormattedMessage id='component.cookie_modal.performance_title' />
                </h3>

                <div className={styles.switchWrapper}>
                  <Switch.Root
                    className={styles.switchRoot}
                    checked={localPreferences.performance}
                    onCheckedChange={() => handleToggle('performance')}
                  >
                    <Switch.Thumb className={styles.switchThumb} />
                  </Switch.Root>
                </div>
              </div>

              <p dangerouslySetInnerHTML={modalPerformance}></p>
            </div>

            <div className={styles.option}>
              <div className={styles.optionHeader}>
                <h3>
                  <FormattedMessage id='component.cookie_modal.targeting_title' />
                </h3>

                <div className={styles.switchWrapper}>
                  <Switch.Root
                    className={styles.switchRoot}
                    checked={localPreferences.targeting}
                    onCheckedChange={() => handleToggle('targeting')}
                  >
                    <Switch.Thumb className={styles.switchThumb} />
                  </Switch.Root>
                </div>
              </div>
              <p dangerouslySetInnerHTML={modalTargeting}></p>
            </div>
          </div>

          <div className={styles.dialogButtons}>
            <div>
              <button
                className='btn start-green'
                onClick={() => onSave({ necessary: true, performance: true, targeting: true })}
              >
                <FormattedMessage id='component.cookie_modal.allow_all' />
              </button>
              <button
                className='btn start-green'
                onClick={() => onSave({ necessary: true, performance: false, targeting: false })}
              >
                <FormattedMessage id='component.cookie_modal.reject_all' />
              </button>
            </div>

            <button className='btn start-green' onClick={handleSave}>
              <FormattedMessage id='component.cookie_modal.save_settings' />
            </button>
          </div>

          <Dialog.Close asChild>
            <button className={styles.dialogClose} aria-label='Close'>
              ×
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CookiePreferencesModal;
